import {createApiResource} from 'data/utils';

const resource = createApiResource({
	name: 'dashboardData',
	pathName: '/dashboardData',
});

export const useDashboardData = resource.createUseQueryIndex();
